import { supabase } from './supabase'
import logger from '../utils/logger'

/**
 * Set up deep link handler for OAuth callbacks on native platforms (Capacitor).
 * Listens for appUrlOpen events and exchanges the PKCE code for a session.
 */
export async function setupDeepLinkHandler() {
  // Only run on native platforms — skip in web browsers
  const isNative = typeof window !== 'undefined' &&
    window.Capacitor?.isNativePlatform?.()

  if (!isNative) return

  const { App } = await import('@capacitor/app')
  const { Browser } = await import('@capacitor/browser')

  App.addListener('appUrlOpen', async ({ url }) => {
    // Match our custom scheme callback: com.press2dn.app://auth/callback?code=...
    if (!url.includes('auth/callback')) return

    const parsedUrl = new URL(url)
    const code = parsedUrl.searchParams.get('code')

    if (code) {
      try {
        await supabase.auth.exchangeCodeForSession(code)
      } catch (err) {
        logger.error('Failed to exchange code for session: ' + err?.message)
        logger.capture(err, { context: 'OAuth code exchange' })
      }
    }

    // Close the external browser that was opened for OAuth
    try {
      await Browser.close()
    } catch {
      // Browser.close() may fail if already closed — ignore
    }
  })
}
